import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AvartarHeader from "components/fragments/AvartarHeader";
import NotifyIcon from "components/fragments/NotifyIcon";
import ModalSuccess from "./modals/ModalSuccess";
import ModalPin from "./modals/PinVerificationModal";
import ChangeEmployeeModal from "./modals/ChangeEmployeeModal";
import CustomInputSearch from "components/fragments/CustomInputSearch";
import { authHandler } from "../redux/handlers";
import { setUser } from "../redux/slices/pos.slice";

export default function POSHeader({ isNotify, isSearch, setFilterText }) {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const { user, branch, pos } = useSelector((state) => state.pos);

  const [modalChangeStaffOpen, setModalChangeStaffOpen] = useState(false);
  const [modalPinOpen, setModalPinOpen] = useState(false);
  const [modalSuccessOpen, setModalSuccessOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const searchTimeout = useRef(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setIsLoading(true);
        const response = await dispatch(authHandler.getUserBusinessProfile(businessSlug));

        if (response) {
          dispatch(setUser(response));
        }
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserProfile();
  }, [businessSlug, dispatch]);

  const handleSearch = (value) => {
    setSearchValue(value);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setFilterText(value);
    }, 800);
  };

  const getUserFullName = () => {
    if (!user) return "...";

    const firstName = user.first_name || "";
    const lastName = user.last_name || "";

    return `${firstName} ${lastName}`.trim();
  };

  const getUserAvatar = () => {
    if (!user) return "/img/avatar-default.png";

    return user.image_path || "/img/avatar-female.png";
  };

  useEffect(() => {
    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, []);

  return (
    <div className="h-[min(5.86vw,60px)] flex items-center py-[min(1.01vw,10.31px)] px-[min(1.62vw,16.55px)] bg-white">
      <div className="mr-[min(10.94vw,112px)]">
        <div className="flex items-center text-14">
          <div className="mr-[min(0.61vw,6.24px)] font-[500]">สาขา :</div>
          <div className="mr-[min(1.37vw,14px)] text-[#575B5E]">{branch?.branch_info?.branch_name || ""}</div>
          <div className="mr-[min(0.49vw,5px)] font-[500]">POS :</div>
          <div className="mr-[min(0.61vw,6.24px)] text-[#575B5E]">{pos && pos.length > 0 ? pos[0].pos_id : ""}</div>
        </div>
        <div className="flex text-12 gap-[min(1.07vw,11px)] items-center">
          <div>พนักงาน :</div>
          <div className="w-[min(1.76vw,18px)] aspect-square">
            <AvartarHeader
              userInfo={{
                avartar: getUserAvatar(),
              }}
            />
          </div>
          <div className="text-[#575B5E]">{isLoading ? "กำลังโหลด..." : getUserFullName()}</div>
          <button onClick={() => setModalChangeStaffOpen(!modalChangeStaffOpen)} className="text-[var(--color-green)] underline">
            เปลี่ยน
          </button>
        </div>
      </div>
      {/* {isNotify && <NotifyIcon countNotify={15} />} */}
      {isSearch && (
        <div className="w-[min(16.70vw,240px)] ml-auto flex space-x-2">
          <button
            onClick={() => {
              handleSearch("");
              setSearchValue("");
            }}
            className="text-[12px] text-nowrap text-[#2DC76D] underline"
          >
            ล้างการค้นหา
          </button>
          <CustomInputSearch
            inputprops={{
              type: "text",
              className: "search-input text-12 pt-2",
              placeholder: "ค้นหาเมนูอาหาร / สินค้า",
              min: 0,
              value: searchValue,
              onChange: (e) => handleSearch(e.target.value),
            }}
            onClear={() => handleSearch("")}
          />
        </div>
      )}

      <ChangeEmployeeModal
        modalOpenObj={{
          modalOpen: modalChangeStaffOpen,
          setModalOpen: setModalChangeStaffOpen,
        }}
        modalPinOpenObj={{
          modalOpen: modalPinOpen,
          setModalOpen: setModalPinOpen,
        }}
        selectedUserIdObj={{
          selectedUserId,
          setSelectedUserId,
        }}
        modalSuccessOpenObj={{
          modalOpen: modalSuccessOpen,
          setModalOpen: setModalSuccessOpen,
        }}
      />

      <ModalPin
        modalOpenObj={{
          modalOpen: modalPinOpen,
          setModalOpen: setModalPinOpen,
        }}
        modalSuccessOpenObj={{
          modalOpen: modalSuccessOpen,
          setModalOpen: setModalSuccessOpen,
        }}
      />

      <ModalSuccess
        modalOpenObj={{
          modalOpen: modalSuccessOpen,
          setModalOpen: setModalSuccessOpen,
        }}
      />
    </div>
  );
}
